var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/colors.ts
var colors = {
  gray00: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f3f3f3",
  gray30: "#e3e3e3",
  gray40: "#cccccc",
  gray50: "#8d8d8d",
  gray60: "#6d6d6d",
  gray70: "#4b4b4b",
  gray80: "#2b2b2b",
  gray90: "#0f0f0f",
  orange10: "#fff8f1",
  orange20: "#fdcca0",
  orange40: "#f8ac67",
  orange60: "#fa8005",
  orange70: "#ea5200",
  orange80: "#ae440a",
  blue10: "#e8f4fa",
  blue20: "#c1f0fc",
  blue40: "#67dfff",
  blue60: "#3ab3d5",
  blue70: "#1d67b6",
  blue80: "#0c3a6b",
  green10: "#f9fed0",
  green20: "#e8f57b",
  green40: "#bacb2a",
  green60: "#8bbd26",
  green70: "#44a112",
  green80: "#215107",
  red10: "#fff8f8",
  red20: "#fec8c9",
  red40: "#f38a8a",
  red60: "#dd4142",
  red70: "#8b0027",
  red80: "#4d0419",
  yellow10: "#fffdf1",
  yellow30: "#fdf4a0",
  yellow40: "#f8ea67",
  yellow60: "#fae205",
  yellow70: "#eac500",
  yellow80: "#ae8a0a"
};

// src/components/index.ts
var components_exports = {};
__export(components_exports, {
  Badge: () => Badge,
  Body: () => Body,
  Button: () => Button,
  Card: () => Card,
  Checkbox: () => Checkbox,
  Dialog: () => Dialog,
  Divider: () => Divider,
  Footer: () => Footer,
  Headline: () => Headline,
  HelpText: () => HelpText,
  Image: () => Image,
  Input: () => Input,
  Label: () => Label,
  Link: () => Link,
  ListBox: () => ListBox,
  Menu: () => Menu,
  Message: () => Message,
  Radio: () => Radio,
  Select: () => Select,
  Slider: () => Slider,
  Switch: () => Switch,
  Table: () => Table,
  Text: () => Text,
  TextArea: () => TextArea,
  Underlay: () => Underlay
});

// src/components/Badge.style.ts
var Badge = {
  base: {
    display: "inline-flex",
    alignItems: "center",
    fontFamily: "body",
    fontSize: "xsmall",
    fontWeight: "body",
    borderRadius: "large",
    border: "2px solid transparent",
    whiteSpace: "nowrap",
    padding: "0.25rem 0.75rem",
    mx: "0.5rem"
  }
};

// src/components/Body.style.ts
var Body = {
  base: {
    m: "none"
  }
};

// src/components/Button.style.ts
var Button = {
  base: {
    cursor: "pointer",
    appearance: "none",
    borderRadius: "small",
    fontSize: "xxsmall",
    lineHeight: "22px",
    height: 24,
    py: 0,
    px: "small",
    bg: "gray30",
    color: "gray70",
    border: "1px solid",
    borderColor: "gray70",
    transition: "all 200ms ease-out",
    "&:hover": {
      bg: "gray00"
    },
    "&:disabled": {
      cursor: "not-allowed",
      color: "gray40",
      bg: "gray00",
      border: "1px solid",
      borderColor: "gray40"
    }
  },
  variant: {
    primary: {
      color: "gray00",
      bg: "primary",
      borderColor: "primary",
      "&:hover": {
        color: "background",
        bg: "orange40",
        borderColor: "orange40"
      }
    },
    secondary: {
      color: "gray70",
      bg: "gray30",
      border: "1px solid",
      outlineColor: "gray70",
      "&:hover": {
        bg: "gray00"
      }
    },
    ghost: {
      color: "secondary",
      border: "1px solid",
      outlineColor: "gray70",
      "&:hover": {
        color: "secondary",
        bg: "gray10",
        cursor: "pointer"
      }
    },
    text: {
      color: "secondary",
      bg: "none",
      border: "none",
      "&:hover": {
        color: "secondary",
        outlineColor: "gray70",
        bg: "gray30",
        cursor: "pointer"
      }
    },
    link: {
      color: "#990000",
      border: "none",
      bg: "none",
      p: "none",
      "&:hover": {
        textDecoration: "underline",
        bg: "none",
        cursor: "pointer"
      }
    }
  },
  size: {
    xxsmall: {
      p: "xxsmall"
    }
  }
};

// src/components/Card.style.ts
var Card = {
  base: {
    position: "relative",
    bg: "#fafaf8",
    borderRadius: "5px",
    p: "xsmall",
    boxShadow: "1px 2px 3px",
    maxWidth: "270px"
  },
  variant: {
    hovering: {
      cursor: "pointer",
      "&:hover": {
        boxShadow: "1px 3px 5px"
      }
    }
  },
  size: {
    small: {
      minHeight: "100px"
    }
  }
};

// src/components/Checkbox.style.ts
var Checkbox = {
  base: {
    label: {
      fontSize: "xxsmall",
      lineHeight: "small",
      "&:disabled": {
        color: "gray30"
      }
    },
    checkbox: {
      borderRadius: "small",
      borderColor: "gray40",
      bg: "gray00",
      p: 2,
      "&:hover": {
        borderColor: "gray50"
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "blue60",
        outlineOffset: 3
      },
      "&:checked": {
        color: "white",
        borderColor: "blue70",
        bg: "blue60"
      },
      "&:indeterminate": {
        color: "white",
        borderColor: "blue70",
        bg: "blue60"
      },
      "&:disabled": {
        bg: "gray30",
        borderColor: "gray40"
      }
    }
  },
  size: {
    small: {
      container: {
        py: "xxsmall"
      }
    }
  }
};

// src/components/Dialog.style.ts
var Dialog = {
  base: {
    container: {
      borderRadius: "2px",
      pl: "large",
      pr: "large",
      pb: "large",
      pt: "small",
      bg: "#ecebe6"
    },
    closeButton: {
      position: "relative",
      height: 24,
      width: 24,
      right: "-24px",
      top: "-8px",
      bg: "primary",
      border: "1px solid ",
      borderColor: "primary",
      borderRadius: "small",
      color: "#FFF",
      "&:hover": {
        bg: "orange40"
      }
    }
  },
  size: {
    medium: {
      container: {
        width: "600px"
      }
    }
  }
};

// src/components/Divider.style.ts
var Divider = {
  base: {
    width: "100%",
    height: "1px",
    bg: "text"
  },
  variant: {
    bold: {
      height: "2px"
    }
  }
};

// src/components/Footer.style.ts
var Footer = {
  base: {
    pt: "xsmall"
  }
};

// src/components/Headline.style.ts
var Headline = {
  base: {
    fontWeight: "heading"
  },
  size: {
    "level-1": {
      fontSize: "xlarge"
    },
    "level-2": {
      fontSize: "large",
      mb: "medium"
    },
    "level-3": {
      fontSize: "medium"
    },
    "level-4": {
      fontSize: "small"
    },
    "level-5": {
      fontSize: "xsmall"
    },
    "level-6": {
      fontSize: "xsmall",
      textTransform: "uppercase"
    }
  }
};

// src/components/HelpText.style.ts
var HelpText = {
  base: {
    container: {
      fontSize: "xxsmall",
      color: "text",
      "&:error": {
        fontSize: "xxsmall",
        color: "error"
      }
    },
    icon: {
      size: "xxsmall"
    }
  }
};

// src/components/Image.style.ts
var Image = {
  base: {}
};

// src/components/Input.style.ts
var Input = {
  base: {
    border: "1px solid",
    borderColor: "#aaa",
    borderRadius: "small",
    lineHeight: "medium",
    py: "0",
    px: "xxsmall"
  }
};

// src/components/Label.style.ts
var Label = {
  base: {
    fontSize: "xxsmall",
    color: "text",
    "&:disabled": {
      color: "gray40"
    },
    "&:required": {
      fontWeight: "bold"
    }
  }
};

// src/components/Link.style.ts
var Link = {
  base: {
    color: "#900",
    "&:hover, &:visited": {
      textDecoration: "none",
      cursor: "pointer"
    },
    "&:disabled": {
      cursor: "disabled"
    }
  },
  variant: {
    menuItemLink: {
      color: "text",
      textDecoration: "none"
    },
    content: {
      "&:hover": {
        textDecoration: "none"
      }
    }
  }
};

// src/components/ListBox.style.ts
var ListBox = {
  base: {
    container: {
      fontSize: "xxsmall",
      background: "gray00",
      px: "xxsmall",
      pb: "xxsmall",
      borderTop: "none",
      borderRight: "1px solid",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
      borderBottomRightRadius: "2px",
      borderBottomLeftRadius: "2px",
      borderColor: "#aaa",
      "&:error": {
        background: "gray00",
        borderTop: "none",
        borderRight: "1px solid",
        borderLeft: "1px solid",
        borderBottom: "1px solid",
        borderBottomRightRadius: "2px",
        borderBottomLeftRadius: "2px",
        borderColor: "error"
      }
    },
    list: {
      outline: "none"
    },
    section: {
      fontSize: "xxsmall",
      fontWeight: "bold",
      lineHeight: "medium",
      px: "xxsmall"
    },
    option: {
      color: "text",
      fontSize: "xxsmall",
      lineHeight: "medium",
      outline: "none",
      cursor: "pointer",
      p: "0 6px 0 15px",
      "&:focus": {
        color: "gray00",
        bg: "#3875d7",
        backgroundImage: "linear-gradient(#3875d7 20%, #2a62bc 90%)"
      },
      "&:selected": {
        color: "gray00",
        bg: "#3875d7",
        backgroundImage: "linear-gradient(#3875d7 20%, #2a62bc 90%)"
      },
      "&:disabled": {
        cursor: "not-allowed",
        color: "gray40"
      },
      "&:hover": {
        bg: "blue60"
      }
    }
  }
};

// src/components/Menu.style.ts
var Menu = {
  base: {
    container: {
      bg: "gray00",
      border: "1px solid",
      borderColor: "gray40",
      borderRadius: "small"
    },
    item: {
      fontSize: "xxsmall",
      px: "xxsmall",
      py: "xxsmall",
      cursor: "pointer",
      "&:hover": {
        color: "gray00",
        bg: "blue60"
      }
    }
  }
};

// src/components/Message.style.ts
var Message = {
  base: {
    container: {
      border: "1px solid",
      pt: "xsmall",
      pb: "small",
      px: "small",
      fontSize: "xxsmall",
      bg: "gray10"
    },
    title: {
      lineHeight: "large"
    },
    content: {
      lineHeight: "small"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      size: 16
    }
  },
  variant: {
    warning: {
      container: {
        borderColor: "warning"
      },
      icon: {
        color: "warning"
      },
      content: {
        color: "warning"
      },
      title: {
        color: "warning"
      }
    },
    error: {
      container: {
        borderColor: "error"
      },
      icon: {
        color: "error"
      },
      content: {
        color: "error"
      },
      title: {
        color: "error"
      }
    },
    info: {
      container: {
        borderColor: "info"
      },
      icon: {
        color: "info"
      },
      content: {
        color: "info"
      },
      title: {
        color: "info"
      }
    }
  }
};

// src/components/Radio.style.ts
var Radio = {
  base: {
    label: {
      fontSize: "xxsmall",
      "&:disabled": {
        color: "gray40"
      }
    },
    radio: {
      borderColor: "gray40",
      "&:hover": {
        borderColor: "gray50"
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "blue60",
        outlineOffset: 3
      },
      "&:checked": {
        color: "white",
        borderColor: "blue70",
        bg: "blue60"
      },
      "&:disabled": {
        bg: "gray30",
        borderColor: "gray40"
      }
    }
  }
};

// src/components/Select.style.ts
var Select = {
  base: {
    button: {
      appearance: "none",
      px: "xxsmall",
      color: "text",
      fontSize: "xxsmall",
      lineHeight: "medium",
      outline: "none",
      cursor: "pointer",
      bg: "gray00",
      border: "1px solid",
      borderColor: "#aaa",
      "&:disabled": {
        bg: "gray20",
        color: "disabled",
        cursor: "not-allowed"
      },
      "&:error": {
        border: "1px solid",
        borderColor: "error"
      },
      "&:expanded": {
        borderTop: "1px solid",
        borderRight: "1px solid",
        borderLeft: "1px solid",
        borderBottom: "none",
        borderColor: "#aaa",
        borderTopRightRadius: "2px",
        borderTopLeftRadius: "2px",
        boxShadow: "0 1px 0 #fff inset",
        backgroundImage: "linear-gradient(#eee 20%, #fff 80%)"
      }
    }
  }
};

// src/components/Slider.style.ts
var Slider = {
  base: {
    track: {
      width: "100%",
      position: "absolute",
      top: 16,
      height: 8,
      border: "none",
      borderColor: "transparent",
      borderRadius: "large",
      color: "transparent",
      bg: "gray30"
    },
    thumb: {
      verticalAlign: "middle",
      border: "4px solid",
      borderColor: "gray70",
      width: 16,
      height: 16,
      bg: "gray00",
      borderRadius: "large",
      "&:focus": {
        border: "4px solid",
        borderColor: "primary"
      },
      "&:disabled": {
        border: "4px solid",
        borderColor: "gray40",
        bg: "gray40"
      }
    },
    label: {
      color: "text",
      fontSize: "xxsmall",
      fontWeight: "body"
    },
    output: {
      color: "text",
      fontSize: "xxsmall",
      fontWeight: "body"
    }
  }
};

// src/components/Switch.style.ts
var Switch = {
  base: {
    track: {
      bg: "gray20",
      boxShadow: `inset 0 0 0 1px ${colors.gray40}`,
      "&:checked": {
        bg: "primary",
        boxShadow: `inset 0 0 0 1px ${colors.orange80}`
      },
      "&:disabled": {
        opacity: 0.5,
        bg: "gray30",
        boxShadow: `inset 0 0 0 1px ${colors.gray40}`
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "blue60",
        outlineOffset: 3
      }
    },
    thumb: {
      boxShadow: "1px 1px 4px rgba(0, 0, 0, 0.25)",
      "&:disabled": {
        bg: "gray20"
      }
    }
  },
  size: {
    large: {
      track: {
        width: 96,
        height: 48,
        borderRadius: 40
      },
      thumb: {
        top: 2,
        width: 44,
        height: 44,
        "&:checked": {
          transform: "translateX(calc(95px - 44px))"
        }
      }
    }
  }
};

// src/components/Table.style.ts
var Table = {
  base: {
    table: { borderCollapse: "collapse" },
    header: {
      py: "xxsmall",
      px: "xsmall",
      cursor: "default",
      color: "gray00",
      bg: "#a9a9a9",
      borderLeft: "1px solid",
      borderRight: "1px solid",
      borderColor: "gray00",
      ":nth-child(odd)": {
        bg: "gray50"
      },
      "&:focus": {
        outlineColor: "orange60"
      }
    },
    row: {
      "&:checked": {
        bg: "orange10"
      },
      "&[data-hover]": {
        bg: "gray20"
      },
      "&:focus-visible": {
        outlineColor: "orange60"
      }
    },
    cell: {
      p: "xsmall",
      color: "text",
      borderBottom: "1px solid",
      borderColor: "gray50",
      "&:focus": {
        outlineColor: "orange60"
      }
    }
  },
  variant: {
    tableLines: {
      header: {
        bg: "none",
        color: "text",
        fontWeight: "400",
        borderBottom: "1px solid",
        borderColor: "#cfcfcf",
        textAlign: "left"
      },
      cell: {
        borderColor: "#cfcfcf"
      }
    },
    tableBorder: {
      header: {
        bg: "none",
        color: "text",
        fontWeight: "400",
        border: "1px solid",
        borderColor: "#cfcfcf",
        textAlign: "left"
      },
      cell: {
        border: "1px solid #cfcfcf"
      }
    }
  }
};

// src/components/Text.style.ts
var Text = {
  base: {
    color: "text",
    fontSize: "xxsmall"
  },
  variant: {
    bold: {
      fontWeight: "bold"
    },
    muted: {
      color: "gray40"
    }
  }
};

// src/components/TextArea.style.ts
var TextArea = {
  base: {
    fontFamily: "body",
    fontSize: "xxsmall",
    padding: "2px",
    color: "text",
    background: "gray00",
    border: 0,
    boxShadow: "0 0 0 1px #aaa",
    outline: "none",
    "&:focus": {
      outline: "2px solid",
      outlineColor: "blue60"
    },
    "&:disabled": {
      cursor: "not-allowed",
      color: "disabled",
      bg: "gray20"
    },
    "&:error": {
      color: "red60"
    }
  }
};

// src/components/Underlay.style.ts
var Underlay = {
  base: {
    bg: "gray70",
    opacity: 0.33
  }
};

// src/index.ts
var theme = {
  breakpoints: ["40em", "52em", "64em"],
  space: {
    none: 0,
    xxsmall: 4,
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 32,
    xlarge: 40,
    xxlarge: 48
  },
  sizes: {
    none: 0,
    xxsmall: 16,
    xsmall: 32,
    small: 40,
    medium: 80,
    large: 120,
    xlarge: 160,
    xxlarge: 240,
    huge: 320,
    epic: 480
  },
  colors: {
    ...colors,
    none: "transparent",
    text: "#511e04",
    background: colors.gray10,
    primary: colors.orange60,
    secondary: colors.gray70,
    disabled: colors.gray40,
    error: "#f33",
    warning: "#d80",
    info: "#008",
    success: "#080"
  },
  root: {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "body",
      bg: "#e7e4e0"
    }
  },
  radii: {
    none: 0,
    small: 2,
    medium: 4,
    large: 8,
    xlarge: 10
  },
  fonts: {
    body: "Arial, Helvetica, sans-serif",
    heading: "Arial, Helvetica, sans-serif"
  },
  fontSizes: {
    xxsmall: "0.875rem",
    xsmall: "1rem",
    small: "1.125rem",
    medium: "1.25rem",
    large: "1.5rem",
    xlarge: "2rem"
  },
  fontWeights: {
    body: 400,
    heading: 900,
    bold: 700
  },
  lineHeights: {
    xsmall: 1,
    small: 1.125,
    medium: 1.5,
    large: 2,
    xlarge: 2.5,
    xxlarge: 3
  },
  components: components_exports
};
var src_default = theme;
export {
  src_default as default
};
